'use client';

import Image from 'next/image';
import { imageTypes } from '@/constants/types';
import React, { useState } from 'react';
import { cn } from '@/utils/cn';

const fallbackMap = {
  [imageTypes.wide]: '/images/wide-fallback.png',
  [imageTypes.tall]: '/images/tall-fallback.png',
  [imageTypes.square]: '/images/square-fallback.png',
  [imageTypes.icon]: '/images/icon-fallback.png',
};

const imageBlurDataURL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';

function ImageComponentV2({
  src = null,
  alt = '',
  className = '',
  type = imageTypes.wide,
  width = 500,
  height = 500,
  unoptimized = true,
  ...rest
}) {
  const [hasError, setHasError] = useState(false);
  const fallbackSrc = fallbackMap[type] || fallbackMap[imageTypes.wide];

  // If there's an error or no source images available, use fallback
  const shouldUseFallback = hasError || !src;

  // Function to determine the appropriate image source
  const determineImageSource = () => {
    if (shouldUseFallback) {
      return fallbackSrc;
    }

    return src;
  };

  // console.log({ src, alt, type });

  return (
    <Image
      quality={72}
      src={determineImageSource()}
      alt={alt}
      className={cn('next-image-component-v2', className)}
      width={width}
      height={height}
      onError={() => {
        if (!hasError) setHasError(true);
      }}
      {...(width >= 40 && height >= 40
        ? { placeholder: 'blur', blurDataURL: imageBlurDataURL }
        : {})}
      // TODO: Remove this when the image optimization is stable
      // This is a temporary fix to avoid issues with Next.js image optimization
      // unoptimized
      // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
      // TODO: experiment with sizes attribute for better performance
      sizes="(max-width: 768px) 100vw, 50vw"
      unoptimized={unoptimized}
      {...rest}
    />
  );
}

export default ImageComponentV2;
